import { AfterViewInit, Component, ElementRef, inject, model, viewChild } from '@angular/core';

import { ModalService } from '../../../services';
import { SummaryTopComponent } from '../../summary-top/summary-top.component';

@Component({
  selector: 'app-yes-no-modal',
  templateUrl: './yes-no-modal.component.html',
  styleUrl: './yes-no-modal.component.scss',
  imports: [SummaryTopComponent],
})
export class YesNoModalComponent implements AfterViewInit {
  private readonly modalService = inject(ModalService);

  private readonly focus = viewChild<ElementRef<HTMLButtonElement>>('focus');

  public readonly header = model<string>();
  public readonly message = model<string>();

  ngAfterViewInit(): void {
    this.focus().nativeElement.focus();
  }

  onYes() {
    this.modalService.close(true);
  }

  onNo() {
    this.modalService.close(false);
  }
}
